var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoTooltip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12650",
    "data-name": "Group 12650",
    transform: "translate(-882 -634)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2666",
    "data-name": "Ellipse 2666",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(882 634)",
    fill: "#007eff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "i",
    transform: "translate(888 645)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "i")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoTooltip);
export default __webpack_public_path__ + "static/media/info-tooltip.469e2b5a.svg";
export { ForwardRef as ReactComponent };